import type { ComponentChildren, JSX } from "preact";
import { type DesignNode, type FrameSlot, safeThemeDesign } from "../../shared/theme-design";
import { findTheme } from "../settings-shared";
import { app, useStore } from "../store";

export const useDesignFrame = () => {
  const settings = useStore(app, (state) => state.me?.settings);
  return safeThemeDesign(findTheme(settings?.theme ?? "system")?.design)?.frame;
};

export const DesignFrame = ({
  node,
  slots,
}: {
  node: DesignNode;
  slots: Record<FrameSlot, ComponentChildren>;
}) => {
  const style = {
    ...(node.type !== "slot"
      ? {
          display: node.type === "grid" ? "grid" : "flex",
          flexDirection: node.type === "row" ? "row" : "column",
          minWidth: 0,
          minHeight: 0,
        }
      : {}),
    ...node.styles,
  } as JSX.CSSProperties;
  return (
    <div data-design-node={node.id} class={`design-node design-${node.type}`} style={style}>
      {node.type === "slot"
        ? slots[node.slot as FrameSlot]
        : node.children?.map((child) => <DesignFrame key={child.id} node={child} slots={slots} />)}
    </div>
  );
};
